import { admBonusAgreements } from "@/graphql/schemas/revenue/utils/admBonusAgreements"
import { checkPermissions } from "@/graphql/schemas/shared/permissions/permissions"
import { DomainObjects, Operations } from "@/graphql/schemas/shared/permissions/permissionsConfig"

export const queryAdmBonusAgreements = {
  async admBonusAgreements(parent, args, context) {
    const { admNumber, year } = args

    const user = context?.user

    await checkPermissions({
      user,
      domainObject: DomainObjects.BONI,
      operation: Operations.READ,
    })

    const { admBonus } = await admBonusAgreements({
      admNumber,
      year,
    })

    if (!admBonus) {
      return {
        items: [],
      }
    }

    return { items: admBonus }
  },
}
